import { Injectable } from '@angular/core';
// import * as Chart from 'chart.js';


@Injectable({
    providedIn: 'root'
})
export class ChartService {
    arrayData: any = [];
    lastElement: any;
    graphData: any;
}
